// extracted by mini-css-extract-plugin
module.exports = {"lifeStats":"_2AhJe","lockFPSBtn":"_2gAd1"};